<template>
    <Head>
        <title>Fiat Gateway: Поля</title>
    </Head>

    <authenticated-layout :notifications="notifications" >
        <v-navigation :gateway="{id:gatewayId}"/>
        <form action="#" method="post"
              @submit.prevent="create"
              class="grid grid-cols-8 p-6 bg-white gap-6"
        >
            <div class="col-span-6 grid grid-cols-6 gap-6 items-center">
                <v-toggle label="Обязательное" v-model="add.required" :error="errors.required"/>
                <v-select label="Тип" v-model="add.type" :error="errors.type" >
                    <option value="input">input</option>
                    <option value="select">select</option>
                    <option value="checkbox">checkbox</option>
                </v-select>
                <v-input label="Название" v-model="add.name" :error="errors.name" />
                <v-input label="Описание" v-model="add.alias" :error="errors.alias" />
                <v-input label="Заполнитель" v-model="add.placeholder" :error="errors.placeholder" />
                <v-input label="По-умолчанию" v-model="add.default" :error="errors.default" />
                <v-input class="col-span-full" label="Regexp" v-model="add.regexp" :error="errors.regexp" />
            </div>
            <div class="col-span-2 flex flex-col justify-between gap-2">
                <v-input-json label="Значения" v-model="add.values" :error="errors.values" />
                <v-button>Добавить</v-button>
            </div>
        </form>
        <div class="grid grid-cols-8 items-start p-6 gap-6 border-t bg-white" v-for="field in result">
            <div class="col-span-6 grid grid-cols-6 gap-6 items-start">
                <div>
                    <v-label>Обязательное</v-label>
                    <span>{{ field.required ? 'Да' : 'Нет' }}</span>
                </div>
                <div>
                    <v-label>Тип</v-label>
                    <span class="text-sm">{{ field.type }}</span>
                </div>
                <div>
                    <v-label>Название</v-label>
                    <span class="text-sm">{{ field.name }}</span>
                </div>
                <div>
                    <v-label>Описание</v-label>
                    <span class="text-sm">{{ field.alias }}</span>
                </div>
                <div>
                    <v-label>Заполнитель</v-label>
                    <span class="text-sm">{{ field.placeholder }}</span>
                </div>
                <div>
                    <v-label>По-умолчанию</v-label>
                    <span class="text-sm">{{ field.default }}</span>
                </div>
                <div class="col-span-full">
                    <v-label>Regexp</v-label>
                    <span class="text-sm">{{ field.regexp }}</span>
                </div>
            </div>

            <div class="col-span-2 flex flex-col justify-between gap-2">
                <div>
                    <v-label>Значения</v-label>
                    <pre class="text-xs border p-1">{{ field.values }}</pre>
                </div>
                <v-button color="red" @click="remove(field)">Удалить</v-button>
            </div>
        </div>
    </authenticated-layout>
</template>

<script>

import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import VNavigation from '@/Components/Navigation/FiatGateways';
import VLabel from '@/Components/Label';
import VButton from "@/Components/Button";
import VInputJson from "@/Components/InputJson";
import VToggle from "@/Components/Toggle";
import VInput from "@/Components/Input";
import VSelect from "@/Components/Select"

export default {
    components: {
        VLabel, VInput, VToggle, VInputJson, VButton, VSelect,
        Head, Link,
        AuthenticatedLayout,
        VNavigation,
    },
    props: {
        errors:Object,
        success: Boolean,
        result: Object,
        gatewayId: Number,
        notifications: Array,
    },
    data() {
        return {
            add: useForm({
                type: 'select',
                name: '',
                alias: '',
                values: {},
                required: true,
                regexp: '',
                placeholder: '',
                default: '',
            }),
        }
    },
    methods: {
        create() {
            const { notifications, route, add, gatewayId } = this;
            notifications.push({
                type: 'success',
                title: 'Добавление поля',
                message: 'Отправка данных...',
                timeout: false,
            });
            add.post(route('fiat.field.create', gatewayId));
        },
        remove(field) {
            const {notifications} = this;
            notifications.push({
                type: 'success',
                title: 'Удаление поля',
                message: 'Отправка данных...',
                timeout: false,
            });
            useForm({}).delete(this.route('fiat.field.delete', field.id));
        },
    },

};
</script>
